import { render, staticRenderFns } from "./BedIcon.vue?vue&type=template&id=3fccb7f4&"
import script from "./BedIcon.vue?vue&type=script&lang=js&"
export * from "./BedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports